<template>
  <div>
    <q-card flat bordered>

      <q-card-section class="q-pa-sm bg-primary">
        <div class="text-subtitle1 text-bold text-white">
          <q-icon name="person" style="font-size: 25px; padding-right: 0.1rem" />
          Remote dispatch actions
        </div>
      </q-card-section>

      <load-board-overview
          :orderId="this.orderId"
          ref="loadBoardOverviewCardRef"
      />

      <q-separator />
      <q-card-section>

        <q-scroll-area style="height: 180px">
          <q-markup-table separator="cell" flat dense bordered v-if="!loading">
            <thead>
            <tr class="text-center">
              <th class="text-left">Listing</th>
              <th class="text-left">Action</th>
              <th class="text-left">When</th>
              <th class="text-left">Status</th>
              <th class="text-left">Removed vehicles ({{countVehicles(remoteDispatchesForOrder.data,true)}})</th>
              <th class="text-left">New vehicles ({{countVehicles(remoteDispatchesForOrder.data,false)}})</th>
              <th class="text-left">Removed stops</th>
              <th class="text-left">New stops</th>
            </tr>
            </thead>
            <tbody v-for="(remote, index) in remoteDispatchesForOrder.data" v-bind:key="index">
            <tr>

              <td class="text-left">

                <div
                    v-if="!remote.existing"
                    class="text-negative"
                >
                  <span>
                    {{remote.remoteReference}}
                  </span>
                </div>

                <div
                    v-if="remote.existing"
                    class="text-positive"
                >
                  <span>
                    {{remote.remoteReference}}
                  </span>
                </div>
              </td>

              <td class="text-left">
                <span v-if="remote.operationType === 'updateToLoadBoard'">
                  Update
                </span>

                <span v-else-if="remote.operationType === 'deleteFromLoadBoard'">
                  Delete
                </span>

                <span v-else-if="remote.operationType === 'postToLoadBoard'">
                  Create
                </span>

                <span v-else>
                   Read listing
                </span>
              </td>

              <td class="text-left">
                {{
                  remote.createdAt | localTime
                }}
              </td>

              <td class="text-left">
                <div
                    v-if="remote.errorFromResponse"
                    class="text-negative text-center"
                >
                  {{ remote.errorFromResponse.message }}
                </div>

                <div
                    v-if="!remote.errorFromResponse"
                    class="text-positive text-center"
                >
                  {{ remote.httpCode??'' }}
                </div>

              </td>

              <td class="text-left">
                <div
                >
                  {{  ((remote.oldVehicles?.length??0) === 0)? '': remote.oldVehicles.length }}
                </div>
              </td>

              <td class="text-left">
                <div
                >
                  {{  ((remote.newVehicles?.length??0) === 0)? '': remote.newVehicles.length }}
                </div>
              </td>

              <td class="text-left">
                <div>
                  {{countStops(remote.oldStops)? countStops(remote.oldStops):''}}
                </div>
              </td>

              <td class="text-left">
                <div
                >
                  {{countStops(remote.newStops)? countStops(remote.newStops):''}}
                </div>
              </td>

            </tr>
            </tbody>
          </q-markup-table>
        </q-scroll-area>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import graphql from '@client/graphql';
import LoadBoardOverview from './load-board-overview';

export default {
  name: 'AppLoadBoardCard',
  props: ['orderId'],
  components: {
    LoadBoardOverview
  },
  apollo: {
    remoteDispatchesForOrder: {
      query: graphql.queries.getRemoteDispatchesForOrder,
      variables() {
        return { orderId: parseInt(this.orderId.toString()) };
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    countStops(stops) {
      if (!stops) { return 0}
      let count = 0;
      if (stops.origin) {count ++;}
      if (stops.destination) {count ++;}
      return count;
    },

    countVehicles(all_rows,is_old) {
      let ret = 0;
       const key = is_old? 'oldVehicles':'newVehicles';
       for(let i = 0; i < all_rows.length; i++){
         const node = all_rows[i];
         if (!node[key] || !node[key].length) {
           continue;
         }
         ret += node[key].length;
       }
       return ret;
    },
    async refreshLoadBoard() {

      this.$apollo.queries.remoteDispatchesForOrder.refetch();
      this.$refs.loadBoardOverviewCardRef.refreshLoadBoardOverview();
    }
  },
};
</script>

